import React from "react";
import { WhatAreWeDoing } from "components/WhatAreWeDoing";
import { OurProcess, OurCases } from "sections/Offers";
import { Clients, Testimonials, ContactPerson } from "sections/Homepage";
import { useContactPersonData } from "shared/Hooks/ContactPerson";

export const OfferLayoutNew = ({ data, data_projects }) => {
  return (
    <>
      {data.what_we_do && <WhatAreWeDoing data={data.what_we_do} />}
      {data.our_process && <OurProcess data={data.our_process} />}
      <OurCases data={data_projects} />
      <Testimonials />
      <Clients />
      {/*<ContactPerson
        margin={1}
        personData={useContactPersonData().jakub_furman}
      />*/}
    </>
  );
};
